import React from "react";

import AssetCustomViewPage from "components/asset-management-system/custom-views/AssetCustomViewPage";

const AssetViewsView: React.FC = () => {
    return <AssetCustomViewPage />;
};

export default AssetViewsView;
